import eye from './icon_eye.js';
import pencil from './icon_pencil.js';

export {
  eye,
  pencil,
};



// WEBPACK FOOTER //
// src/icons/index.js